// Provider
export {
  SocketManagerProvider,
  default,
  type SocketManagerProviderProps,
} from './socket-manager-provider';

// Context
export {
  SocketManagerContext,
  useSocketManagerContext,
  type SocketManagerContextValue,
} from './context';

// Legacy WebSocket Provider (for backwards compatibility)
export { default as WebSocketProvider } from './websocket/websocket-provider';
